import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapEstablishmentToApiEstablishmentDto = (values: IEditEstablishmentForm): IPostEditEstablishment | {} => {
  let dataMapping: IPostEditEstablishment;
  const unknown = -1;

  if (values.placeID === undefined || values.modemID === undefined) { return {}; }

    dataMapping = {
      description: values.description,
      placeID: +values.placeID !== 0 ? +values.placeID : unknown,
      modemID: +values.modemID !== 0 ? +values.modemID : unknown,
      modemPort: values.modemPort,
      unID: values.unID,
      sapCode: values.sapCode,
      deleted: false,
      filepath:values.filepath,
      hubType: values.hubType,
      anetVoice: values.anetVoice,
      comments: values.comments,
      isEmporiki: values.isEmporiki,
      isCiti: values.isCiti,
    }
  
  return dataMapping;
}


const editEstablishment = ( {data, establishmentId} : {data: IEditEstablishmentForm , establishmentId: number}): Promise<string> => {
  const establishment = mapEstablishmentToApiEstablishmentDto(data);
  return axiosDefaultApi.put(`/api/Establishments/UpdateEstablishment/${establishmentId}`, establishment);
};

type QueryFnType = typeof editEstablishment;

type UseEditEstablishmentOptions = {
  data: IPostEditEstablishment | {};
  establishmentId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditEstablishment = ({ config }: UseEditEstablishmentOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Καταστήματος.`, 500);
            console.error('Couldnt edit Establishment', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllEstablishments"])
            addNotification('Το Κατάστημα Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editEstablishment,
    })
}